export default happeningsConfig;

/** @ngInject */
function happeningsConfig($stateProvider, modulesProvider) {
  modulesProvider.registerModule({
    title: 'Wydarzenia',
    state: 'modules.happenings',
    showInMenu: true,
    permissions: ['ALL']
  });

  $stateProvider
    .state('modules.happenings', {
      url: '/happenings',
      views: {
        'content@': {
          component: 'happeningsComponent'
        }
      },
      resolve: {
        happenings: HappeningService => HappeningService.getAll(true)
      }
    })
    .state('modules.happenings.add', {
      url: '/add',
      data: {
        title: 'Dodaj nowe wydarzenie',
        displayName: 'Dodaj nowe wydarzenie'
      },
      views: {
        'content@': {
          component: 'addHappeningComponent'
        }
      },
      resolve: {
        students: StudentService => StudentService.getAll()
      }
    })
    .state('modules.happenings.edit', {
      url: '/edit/:id',
      data: {
        title: 'Edytuj wydarzenie',
        displayName: 'Edytuj wydarzenie'
      },
      views: {
        'content@': {
          component: 'editHappeningComponent'
        }
      },
      resolve: {
        happening: (HappeningService, $stateParams) => HappeningService.get($stateParams.id)
      }
    });
}
